import { render } from "./LoginForm.vue?vue&type=template&id=9fce5d5c&scoped=true&ts=true"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"

import "./LoginForm.vue?vue&type=style&index=0&id=9fce5d5c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fce5d5c"]])

export default __exports__